import { Form, Formik } from "formik";
import type { ContextModules, SetupAssistantForm } from "./setupAssistant.types";
import { finishValidationSchema } from "./setupAssistantUtils";
import { useSetupAssistantFinish } from "./hooks/useSetupAssistantFinish";
import { useModulesInput } from "./hooks/useModulesInput";
import { SetupAssistantFormContent } from "./components/SetupAssistantFormContent";

export interface FinalForm {
	modulesList: string[];
	landUse_start: number | undefined;
	landUse_w: number | undefined;
	landUse_wo: number | undefined;
	area: number | undefined;
}
const initValues: FinalForm = {
	modulesList: [],
	area: undefined,
	landUse_start: undefined,
	landUse_w: undefined,
	landUse_wo: undefined,
};

interface SetupAssistantFinishProps {
	modules: ContextModules[];
	onReturn?: () => void;
	values: SetupAssistantForm;
}

const SetupAssistantFinish = ({
	modules,
	values,
	onReturn,
}: SetupAssistantFinishProps) => {
	const {
		// State
		isEdit,
		isLoading,
		isSubmitting,
		isError,
		errorMsg,
		showConfirmModal,
		
		// Data
		preSelected,
		area,
		lucs,
		
		// Handlers
		handleSubmit,
		handleCancel,
		handleConfirm,
	} = useSetupAssistantFinish(modules, values);

	const modulesInput = useModulesInput();

	const initialValues = {
		...initValues,
		modulesList: [...preSelected],
		area: area,
		...lucs
	};

	return (
		<section>
			<Formik
				initialValues={initialValues}
				enableReinitialize
				onSubmit={handleSubmit}
				validationSchema={finishValidationSchema}
			>
				{({ isValid, submitForm, errors, touched }) => (
					<Form>
						<SetupAssistantFormContent
							modulesInput={modulesInput}
							isEdit={isEdit}
							isLoading={isLoading}
							isSubmitting={isSubmitting}
							isValid={isValid}
							isError={isError}
							errorMsg={errorMsg}
							showConfirmModal={showConfirmModal}
							errors={errors}
							touched={touched}
							onReturn={onReturn}
							onCancel={handleCancel}
							onConfirm={handleConfirm}
							submitForm={submitForm}
						/>
					</Form>
				)}
			</Formik>
		</section>
	);
};

export default SetupAssistantFinish;
